import { CollapseAllButton, ExpandAllButton } from '@/finsight/ui/components/deals/DealListTable/components/DealButtons';

interface ITriggerExpandProps {
    setIsRowsExpanded: (isRowsExpanded: boolean) => void,
    isRowsExpanded: boolean,
}

export const TriggerExpand = ({ setIsRowsExpanded, isRowsExpanded }: ITriggerExpandProps) => {
    return isRowsExpanded ? (
      <CollapseAllButton onClick={ () => {
            setIsRowsExpanded(false);
        } }
      />
    ) : (
      <ExpandAllButton onClick={ () => {
            setIsRowsExpanded(true);
        } }
      />
    );
};
